import { render, staticRenderFns } from "./ActionConfig.vue?vue&type=template&id=6910d7b8&scoped=true"
import script from "./ActionConfig.vue?vue&type=script&lang=js"
export * from "./ActionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910d7b8",
  null
  
)

export default component.exports